import React, {useEffect, useState} from "react";
import {Button, Modal} from "react-bootstrap";
import {toPersianNumber} from "../../util/DominantUtil";
import axios from "../plugins/axios";

export default function InternetChargePaymentModal(props) {
    const [paymentUri, setPaymentUri] = useState(null);

    useEffect(() => {
        if (props) makePaymentUri(makeParams(props), props.price);
    }, []);

    function makePaymentUri(params, price) {
        axios
            .post(`/bill?${params}`, {price: price, quantity: 1}).then((response) => {
            setPaymentUri(response.data.paymentUrl);
        }).catch((error) => {
            console.log(error)
        });
    }

    function paymentOnClickHandler() {
        if (paymentUri) window.open(paymentUri, '_ blank');
    }

    return <>
        {props &&
        <Modal show={props.show} onHide={props.onHide}>
            <Modal.Header className="text-center">
                <div
                    className={`rounded-full mx-auto -mt-10 ${props.enName + "-bg-color"}`}
                    style={{width: "65px", height: "65px"}}>
                    <img className="h-14 w-14" style={{margin: "6px auto"}}
                         src={`/images/sim-card-recharge/${props.enName}.png`}/>
                </div>
            </Modal.Header>
            <Modal.Body>
                <div className="text-center">
                    <Modal.Title>مشخصات خرید</Modal.Title>
                </div>
                <div>
                    <div className="modal-body text-right">
                        <div className="row">
                            <table className="table table-borderless px-0" style={{direction: 'rtl'}}>
                                <tr>
                                    <td className="font-bold">شماره موبایل:</td>
                                    <td className="text-left">{toPersianNumber(props.mobileNumber)}</td>
                                </tr>
                                <tr>
                                    <td className="font-bold">بها:</td>
                                    <td className="text-left">{toPersianNumber(props.price.toLocaleString())} ریال</td>
                                </tr>
                                <tr>
                                    <td className="font-bold">نوع سیم کارت:</td>
                                    <td className="text-left">{props.pType}</td>
                                </tr>
                                <tr>
                                    <td className="font-bold">بسته انتخابی:</td>
                                    <td className="text-left">{toPersianNumber(props.pName)}</td>
                                </tr>
                            </table>
                        </div>
                        <div className="row">
                            <p className="text-gray-400">نکته: لطفا به نوع سیمکارت دقت نمایید. در صورت مغایرت، عملیات
                                ناموفق خواهد بود.</p>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="row w-100">
                    <Button variant="primary"
                            className={`col-8 buy-btn h-14 rounded-custom ${!paymentUri && 'btn-disabled'}`}
                            onClick={() => {
                                paymentUri && paymentOnClickHandler();
                                paymentUri && props.onHide();
                            }}>
                        پرداخت
                    </Button>
                    <Button variant="secondary" className="col-4 text-secondary h-14 rounded-custom"
                            onClick={props.onClick}>
                        انصراف
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
        }
    </>
}

function makeParams(props) {
    return "mobileNumber=" + props.mobileNumber + "&product=" + props.product + "&type=" + props.type +
        "&profile_id=" + props.profileId + "&referrer=WEB&opType=SIM_INTERNET_CHARGE";
}